module.exports = __webpack_public_path__ + "img/4.9e49b1f2.webp";